// extracted by css-extract-rspack-plugin
export default {"fit-to-content-height":"QrIus","fitToContentHeight":"QrIus","height-overflow":"bsFmQ","heightOverflow":"bsFmQ"};